export var RelativeDateOpOption;
(function (RelativeDateOpOption) {
    RelativeDateOpOption["TODAY"] = "TODAY";
    RelativeDateOpOption["YESTERDAY"] = "YESTERDAY";
    RelativeDateOpOption["THIS_WEEK"] = "THIS_WEEK";
    RelativeDateOpOption["LAST_WEEK"] = "LAST_WEEK";
    RelativeDateOpOption["THIS_MONTH"] = "THIS_MONTH";
    RelativeDateOpOption["LAST_MONTH"] = "LAST_MONTH";
    RelativeDateOpOption["THIS_QUARTER"] = "THIS_QUARTER";
    RelativeDateOpOption["LAST_QUARTER"] = "LAST_QUARTER";
    RelativeDateOpOption["THIS_YEAR"] = "THIS_YEAR";
    RelativeDateOpOption["LAST_YEAR"] = "LAST_YEAR";
    RelativeDateOpOption["LAST_7_DAYS"] = "LAST_7_DAYS";
    RelativeDateOpOption["LAST_14_DAYS"] = "LAST_14_DAYS";
    RelativeDateOpOption["LAST_30_DAYS"] = "LAST_30_DAYS";
    RelativeDateOpOption["LAST_60_DAYS"] = "LAST_60_DAYS";
    RelativeDateOpOption["LAST_90_DAYS"] = "LAST_90_DAYS";
    RelativeDateOpOption["LAST_180_DAYS"] = "LAST_180_DAYS";
    RelativeDateOpOption["LAST_365_DAYS"] = "LAST_365_DAYS";
})(RelativeDateOpOption || (RelativeDateOpOption = {}));
export const RelativeDateOpOptionLabel = {
    [RelativeDateOpOption.TODAY]: 'Today',
    [RelativeDateOpOption.YESTERDAY]: 'Yesterday',
    [RelativeDateOpOption.THIS_WEEK]: 'This Week',
    [RelativeDateOpOption.LAST_WEEK]: 'Last Week',
    [RelativeDateOpOption.THIS_MONTH]: 'This Month',
    [RelativeDateOpOption.LAST_MONTH]: 'Last Month',
    [RelativeDateOpOption.THIS_QUARTER]: 'This Quarter',
    [RelativeDateOpOption.LAST_QUARTER]: 'Last Quarter',
    [RelativeDateOpOption.THIS_YEAR]: 'This Year',
    [RelativeDateOpOption.LAST_YEAR]: 'Last Year',
    [RelativeDateOpOption.LAST_7_DAYS]: 'Last 7 Days',
    [RelativeDateOpOption.LAST_14_DAYS]: 'Last 14 Days',
    [RelativeDateOpOption.LAST_30_DAYS]: 'Last 30 Days',
    [RelativeDateOpOption.LAST_60_DAYS]: 'Last 60 Days',
    [RelativeDateOpOption.LAST_90_DAYS]: 'Last 90 Days',
    [RelativeDateOpOption.LAST_180_DAYS]: 'Last 180 Days',
    [RelativeDateOpOption.LAST_365_DAYS]: 'Last 365 Days',
};
